"use client";
import React, { useEffect, useState, useRef } from 'react';
import Image from "next/image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import TestUser1 from "@/Helper/images/new/test_user1.png";
import TestimonailsTop1secure from "@/Helper/images/new/testimonails_top1.svg";
import { apiService } from "@/services/api.services";
const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        },
    },
  ],
};
const Testimonials = ({ testimonials = [] }) => {
  // const [items, setItems] = useState([]);
  const sliderRef = useRef(null); // ✅ Fix: Added useRef for slider control
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        setIsLoading(true);
        const data = await apiService.testimonials();
        console.log("Full API Response Data:", data);

        const testimonials = Array.isArray(data) ? data : data?.data || [];
        setItems(testimonials);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTestimonials();
  }, []);
  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };





  return (
    <div className="container-xxl testimonials_section mb-2">
      <div className="container home_page_members">
        <div className="testimonials_section_row">
          {/* LEFT SECTION */}
          <div className="testimonials_section_col">
            <div className="test_user_left">
              <div className="testimonials_top">
                <Image
                  className="lazy-image"
                  src={TestimonailsTop1secure}
                  alt="Customer Happiness Guaranteed"
                  width="30"
                  height="30"
                />
                 <Image
                  className="lazy-image"
                  src={TestimonailsTop1secure}
                  alt="Customer Happiness Guaranteed"
                  width="30"
                  height="30"
                />
                 <Image
                  className="lazy-image"
                  src={TestimonailsTop1secure}
                  alt="Customer Happiness Guaranteed"
                  width="30"
                  height="30"
                />
                 <Image
                  className="lazy-image"
                  src={TestimonailsTop1secure}
                  alt="Customer Happiness Guaranteed"
                  width="30"
                  height="30"
                />
                 <Image
                  className="lazy-image"
                  src={TestimonailsTop1secure}
                  alt="Customer Happiness Guaranteed"
                  width="30"
                  height="30"
                />
              </div>
              <p className="testuser_head">
                Customer<br />
                <span>Happiness</span><br />
                Guaranteed
              </p>
              <p className="testuser_content">
                There are many reasons why our partners love <br />
                to work with us.
              </p>
              <div className="slider_arrowouter">
                <button
                  onClick={handlePrev}
                  className="slider-arrow slider-arrowprev"
                  disabled={items.length <= 2}
                >

                </button>
                <button
                  onClick={handleNext}
                  className="slider-arrow slider-arrownext"
                  disabled={items.length <= 2}
                >

                </button>
              </div>
            </div>
          </div>

          {/* RIGHT SECTION (SLIDER) */}
          <div className="testimonials_section_colright">
            <Slider ref={sliderRef} {...settings}>
              {items.map((testimonial, index) => (
                <div className="item" key={index}>
                  <div className="members_list">
                    <span className="qts_icon"></span>
                    <p className="user_testfulldesc">
                      {testimonial.description.length > 250
                        ? `${testimonial.description.substring(0, 250)}...`
                        : testimonial.description}
                    </p>
                    <div className="user_imgrow">
                      <div className="user_img">
                        {/* <Image
                          className="img-fluid w-100 lazy-image"
                          src={testimonial.image}
                          alt={testimonial.name}
                          width="63"
                          height="63"
                          loading="lazy"
                        /> */}
                        <Image
                          className="img-fluid w-100 lazy-image"
                          src={
                            testimonial.image?.formats?.small?.url ||
                            testimonial.image?.url ||
                            "/default-image.png"
                          }
                          alt={testimonial.name}
                          width="63"
                          height="63"
                          loading="lazy"
                        />
                      </div>
                      <div className="user_imgright">
                        <p className="test_username">{testimonial.name}</p>
                        <p className="test_userpost">
                          ({testimonial.company.charAt(0).toUpperCase() + testimonial.company.slice(1)})
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
